var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.063,
    height: 11.363,
    viewBox: "0 0 19.063 11.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a6acb5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -98.725)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.531,98.725c-3.642,0-6.945,1.993-9.382,5.229a.755.755,0,0,0,0,.9c2.437,3.24,5.74,5.233,9.382,5.233s6.945-1.993,9.382-5.229a.755.755,0,0,0,0-.9C16.476,100.718,13.173,98.725,9.531,98.725Zm.261,9.682a4.009,4.009,0,1,1,3.74-3.74A4.012,4.012,0,0,1,9.793,108.407Zm-.121-1.848a2.159,2.159,0,1,1,2.016-2.016A2.155,2.155,0,0,1,9.672,106.559Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.76ede1b381a16acf99e6fd7ec69449cd.svg";
export { ForwardRef as ReactComponent };